import {
	StoryReply,
	StoryReplyInput,
	StoryReplyButton,
} from '../../StoryViewer.styles';

const StoryViewerReply = ({ placeholder, submitLabel, onSubmit }) => (
	<StoryReply onSubmit={onSubmit}>
		<StoryReplyInput
			type="text"
			placeholder={placeholder}
			autoComplete="off"
		/>
		<StoryReplyButton type="submit">{submitLabel}</StoryReplyButton>
	</StoryReply>
);

export default StoryViewerReply;
